export default __webpack_public_path__ + "static/media/test.d82468b7.png";